export const WORKER_CONCURRENCY = 2;

export const DEFAULT_VALID_UNTIL_DAYS = 14;
export const DEFAULT_ITEM_DURATION_HOURS = 2;
export const MAX_ITEM_DURATION_HOURS = 23;

export const DISPLAY_DATE_FORMAT = "yyyy-MM-dd";
export const DISPLAY_DATETIME_FORMAT = "yyyy-MM-dd HH:mm:ss";
export const DISPLAY_WEEK_HEADER_FORMAT = "MMM d";
export const DISPLAY_DAY_FORMAT = "EEE, MMM d";
export const DISPLAY_TIME_FORMAT = "h:mm a";
